import { forwardRef } from 'react';

import { ChipProps, ComboboxItem, Group, Input, Stack } from '@ui';

import { CustomChip } from './CustomChip';

export interface ChipSelectProps {
  label?: string;
  value?: string[];
  data?: ComboboxItem[];
  maxSelections?: number;
  error?: string;
  onChange?: (value: string[]) => void;
  disabled?: boolean;
  chipProps?: Omit<ChipProps, 'onClick' | 'children'>;
}

const ChipSelect = forwardRef<HTMLDivElement, ChipSelectProps>(
  (
    { value, onChange, data, label, maxSelections, error, disabled, chipProps },
    ref
  ) => {
    const _maxSelections = maxSelections ?? data?.length ?? 0;

    const handleChipClick = (item: ComboboxItem) => {
      if (value?.includes(item.value)) {
        onChange?.(value.filter((v) => v !== item.value));
      } else if (
        !value?.includes(item.value) &&
        (value?.length ?? 0) < _maxSelections
      ) {
        onChange?.([...(value ?? []), item.value]);
      }
    };

    return (
      <Stack gap="0" ref={ref}>
        {label && <Input.Label>{label}</Input.Label>}
        <Group gap="xs">
          {data?.map((item) => {
            return (
              <CustomChip
                key={item.value}
                option={item}
                checked={(value && value?.includes(item.value)) ?? false}
                disabled={
                  (!!maxSelections &&
                    (value?.length ?? 0) >= _maxSelections &&
                    !value?.includes(item.value)) ||
                  disabled
                }
                {...chipProps}
                onClick={handleChipClick}
              />
            );
          })}
        </Group>
        {error && <Input.Error mt="sm">{error}</Input.Error>}
      </Stack>
    );
  }
);

export { ChipSelect };
